import { Notification } from '@app/components/various/Notification';
import { getDeliveryWindowMap } from '@app/ducks';
import { isDefined } from '@app/utils/is';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface Props {
  deliveryWindowIds: string[];
}

export const ExpiredDeliveryWindowsFailure = ({ deliveryWindowIds }: Props) => {
  const { t } = useTranslation(['checkoutMessages']);

  const deliveryWindowsMap = useSelector(getDeliveryWindowMap);
  const expiredDelwinNames = deliveryWindowIds
    .map(id => deliveryWindowsMap[id]?.name)
    .filter(isDefined)
    .join(', ');

  return (
    <div className="flex w-full flex-col gap-5">
      <Notification type="error" message={t('checkoutMessages:expired_delwins_error.header')} />
      <p className="whitespace-pre-wrap body-2">
        <Trans t={t} i18nKey="checkoutMessages:expired_delwins_error.details" values={{ expiredDelwinNames }}>
          Following delivery windows have expired: <span className="body-1">{expiredDelwinNames}</span>. Please make sure to remove the
          products from expired delivery windows and repeat the checkout.
        </Trans>
      </p>
    </div>
  );
};
